// Auto generated file, do not manually modify!
// com.hotpads.rentalgrowth.web.market.marketpage.handler.RentalGrowthMarketTrendsSummaryWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetMarketTrendsSummaryRequestDto, GetMarketTrendsSummaryResponseDto } from '../..';

export const RentalGrowthMarketTrendsSummaryWebApiHandler_summary_Path = '/api/web/v1/marketTrends/summary';

export const RentalGrowthMarketTrendsSummaryWebApiHandler_summary = (
  postData: GetMarketTrendsSummaryRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetMarketTrendsSummaryRequestDto, GetMarketTrendsSummaryResponseDto>(
    {
      endpoint: RentalGrowthMarketTrendsSummaryWebApiHandler_summary_Path,
      method: 'POST',
      contextPath: '/rental-growth-api',
      postData: postData,
    },
    client,
  );
};
